import GooleMapContainer from "./GoogleMapContainer";

export default GooleMapContainer;
